export default __webpack_public_path__ + "static/media/logOut.5a0c1aec.svg";